import React from 'react'
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '../../lib/ui/form'
import { RadioGroup, RadioGroupItem } from '../../lib/ui/radio-group'
import { cn } from '../../lib/utils'

export function MultiPartField({
  name,
  label,
  questions,
  choices,
  control,
  programSurvey = false,
}) {
  const fieldId = React.useId()

  const checkedStyles = programSurvey
    ? 'has-[:checked]:bg-primary has-[:checked]:text-primary-foreground'
    : 'has-[:checked]:border-primary has-[:checked]:bg-accent has-[:checked]:text-accent-foreground'

  return (
    <div className="flex flex-col rounded-md ring-offset-background transition-colors">
      <div id={`${fieldId}-label`} className={'text-medium mb-4 font-medium'}>
        {label}
      </div>
      {Object.entries(questions).map(([key, question]) => {
        const questionId = `${fieldId}-${key}`

        return (
          <FormField
            key={key}
            control={control}
            name={`${name}.${key}`}
            render={({ field, fieldState }) => {
              const descriptionId = `${questionId}-help`
              const errorId = `${questionId}-error`
              const describedBy = fieldState.error
                ? `${descriptionId} ${errorId}`
                : descriptionId

              return (
                <FormItem className="my-4 flex flex-col">
                  <FormLabel id={`${questionId}-label`}>
                    {question.name}
                  </FormLabel>
                  <FormDescription
                    id={descriptionId}
                    className="mt-2 text-sm text-[#5d5d5d]"
                  >
                    Select one option
                  </FormDescription>
                  <FormControl>
                    <RadioGroup
                      onValueChange={field.onChange}
                      value={field.value}
                      name={field.name}
                      aria-labelledby={`${fieldId}-label ${questionId}-label`}
                      aria-describedby={describedBy}
                      aria-invalid={fieldState.invalid}
                      className="flex flex-col md:flex-row"
                    >
                      {choices.map((choice, idx) => (
                        <div
                          className="items-left flex-grow space-x-3 space-y-0"
                          key={choice.value}
                        >
                          <label
                            htmlFor={`${questionId}-${idx}-input`}
                            className={cn(
                              `flex cursor-pointer items-center rounded-md border border-[#b0b0b0] px-3 py-2 text-muted-foreground hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground has-[:focus-visible]:outline-none has-[:focus-visible]:ring-2 has-[:focus-visible]:ring-ring has-[:focus-visible]:ring-offset-2 md:justify-center`,
                              checkedStyles,
                            )}
                          >
                            <RadioGroupItem
                              id={`${questionId}-${idx}-input`}
                              className="sr-only"
                              value={choice.value}
                              aria-label={choice.label}
                              aria-describedby={describedBy}
                            />
                            {choice.label}
                          </label>
                        </div>
                      ))}
                    </RadioGroup>
                  </FormControl>
                  <FormMessage id={errorId} aria-live="polite" />
                </FormItem>
              )
            }}
          />
        )
      })}
    </div>
  )
}
